// https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
export enum MouseEventButton {
  NoButton = 0,
  PrimaryButton = 1,
  SecondaryButton = 2,
  AuxiliaryButton = 4,
}
